import { TermsOfUseTemplate } from "../../Templates/TermsOfUseTemplate";

export const TermsOfUse = () => {
  return <TermsOfUseTemplate />;
};
